import React from 'react';
import {
  ButtonBase, Stack, Typography, Icon,
} from '@mui/material';

const styles = {
  button: {
    background: '#ffff',
    color: '#03295F',
    minHeight: '34px',
    fontSize: '13px',
    fontWeight: 700,
    borderRadius: '10px',
    border: '2px solid #03295F',
    width: 'fit-content',
  },
  buttonText: {
    color: 'inherit',
    fontSize: 'inherit',
    fontWeight: 'inherit',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    maxWidth: 'calc(15ch + 10vw)',
  },
  buttonImg: {
    height: '21px',
    width: '21px',
  },
};

const FileUploadButton = ({ onClick, overrideStyle, label }) => {
  if (!label || !onClick) {
    return null;
  }
  const buttonStyles = {
    ...styles.button,
    ...overrideStyle,
  };

  return (
    <ButtonBase onClick={onClick} sx={buttonStyles} id="file-upload-button">
      <Stack direction="row" alignItems="center" spacing={0.5} sx={{ px: '5px' }}>
        <Icon>
          <img src="/assets/profile/story/file-upload.svg" alt="file icon" />
        </Icon>
        <Typography sx={styles.buttonText}>{label}</Typography>
      </Stack>
    </ButtonBase>
  );
};
export default FileUploadButton;
